import React, { useMemo, useState } from "react"
import { Row, Col, Card, CardBody, Table, CardTitle } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    
      <CommonTableContainer
          columns={columns}
          data={data}
          // status={true}
      />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
      <Pagi2
            gotoPage={gotoPage}
            previousPage={previousPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ViewContacts = ({ customer_contact }) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "cus_name",
        isInfoIcon: false,
        className:"cus_name",
        Cell : cellprops =>{
          return(
            <div className="">
              {cellprops.row.original?.name || "-"}
            </div>
          )
        }
      },
      {
        Header: "Email",
        accessor: "cus_email",
        isInfoIcon: false,
        className:"cus_email",
        Cell : cellprops =>{
          return(
            <div className="">
              {cellprops.row.original?.email || "-"}
            </div>
          )
        }
      },
      {
        Header: "Position",
        accessor: "cus_position",
        isInfoIcon: false,
        className: "cus_position",
        Cell: cellprops =>{
          return(
            <div className="">
              {cellprops.row.original?.position	 || "-"}
            </div>
          )
        }
      },
      {
        Header: "Phone",
        accessor: "cus_phone",
        isInfoIcon: false,
        className:"cus_phone",
        Cell: cellprops =>{
          return(
            <div className="">
              {cellprops.row.original?.phone || "-"}
            </div>
          )
        }
      },
      {
        Header: "Primary Contact",
        accessor: "cus_primary",
        isInfoIcon: false,
        className:"cus_primary",
        Cell: cellProps => {

          return (
            <span className="form-switch form-switch-md me-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizemd"
                checked={cellProps.row.original.primarycontact == 'on'}
                onChange={() => {}}
                disabled
              />
            </span>
          )
        },
      },
    ],
    []
  )

  // const data = [
  //   {
  //     cus_name: "Zithas Tchnologies", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  //   {
  //     cus_name: "Jean Theraphy", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  //   {
  //     cus_name: "Global Tchnologies", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  //   {
  //     cus_name: "Bio Tchnologies", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  //   {
  //     cus_name: "Nobal India Tchnologies", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  //   {
  //     cus_name: "Zithas Tchnologies", 
  //     cus_email: "info@zithas.com",
  //     cus_position: "Marketing Manager",
  //     cus_phone: "6585454545",
  //     cus_primary: "9985454545"
  //   },
  // ]

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                <CardTitle className="mb-4 text-dark">Contacts</CardTitle>

                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={customer_contact || [] }
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewContacts
